import { __assign } from "tslib";
var markets;
(function (markets) {
    markets[markets["de"] = 1000] = "de";
    markets[markets["at"] = 1001] = "at";
    markets[markets["ch"] = 1002] = "ch";
    markets[markets["fr"] = 1003] = "fr";
})(markets || (markets = {}));
var locales;
(function (locales) {
    locales[locales["de"] = 0] = "de";
    locales[locales["at"] = 1] = "at";
    locales[locales["ch"] = 2] = "ch";
    locales[locales["fr"] = 3] = "fr";
})(locales || (locales = {}));
var localeAction = function () {
    var path = window.location.pathname;
    var pathSegmentArray = path.split('/');
    return __assign(__assign(__assign(__assign({}, (pathSegmentArray[1].toLowerCase() in locales && { language: pathSegmentArray[1].toLowerCase() })), (pathSegmentArray[1].toLowerCase() in locales && { country: pathSegmentArray[1].toUpperCase() })), (pathSegmentArray[1].toLowerCase() in locales && { market: markets[pathSegmentArray[1].toLowerCase()] })), { client: 1001 });
};
export default localeAction;
